import React from "react";

import DateUtil from "../../common/dateUtil";
import DataRenderer from "../../common/dataRenderer";
import PreTradeDetail from "./PreTradeDetail";

const PreTradePreviewComp = (props) => {
    let statusClass = "panel-status";
    if (props.config && props.config.status && props.config.status.state) {
        statusClass = `${statusClass} ${props.config.status.state}`;
    }

    return (
        <div className="panel">
            
            <div className="panel-header">
                <div className="panel-header-label">{props.config.title}</div>
            </div>

            <PreTradeDetail data={props.data} mode="PREVIEW"/>

            <div className="panel-footer">
                <div className={statusClass}>{props.config.status.message}</div>
                <div className="btn-group">
                <button type="button" id="btnCancel" className="btn btn-primary-outline" onClick={props.config.btnCancel.handler}>{props.config.btnCancel.label}</button>
                    {(props.config.editorMode === "NEW" || (props.config.editorMode === "UPDATE" &&  props.config.detailMode==="PREVIEW")) && 
                        <button type="button" id="btnSave" className="btn btn-primary" onClick={props.config.btnOk.handler}>{props.config.btnOk.label}</button>
                    }
                </div>
            </div>
            
        </div>
    );
};

export default PreTradePreviewComp;
